// TODO: Rename and move this to under appropriate common folder

import { useState } from 'react';
import { StepStatus } from '@frontend/design-system';

export type UseStepperFormActionsProps = {
  initialActiveStep?: number;
  maxStep: number;
};

export type StepsValidationData = {
  isPopulated: boolean;
  hasError: boolean;
}[];

export const useStepperFormActions = ({ initialActiveStep, maxStep }: UseStepperFormActionsProps) => {
  const getStepsValue = (): StepStatus =>
    Object.fromEntries(Array.from({ length: maxStep }, (_, index) => [index + 1, index === 0 ? 'active' : 'inactive']));

  const [stepStatus, setStepStatus] = useState<StepStatus>(getStepsValue());
  const [activeStep, setActiveStep] = useState<number>(initialActiveStep || 1);

  const next = () => {
    const nextStep = Math.min(activeStep + 1, maxStep);
    setActiveStep(nextStep);
  };

  const previous = () => {
    const previousStep = Math.max(activeStep - 1, 1);
    setActiveStep(previousStep);
  };

  const finish = () => {
    setActiveStep(maxStep + 1);
  };

  const getValidStepNumber = (step: number): number => {
    if (step > maxStep) return maxStep;
    if (step < 1) return 1;
    return step;
  };

  const skipTo = (step: number) => {
    if (step === activeStep) return;
    const validatedStep = getValidStepNumber(step);
    setActiveStep(validatedStep);
  };

  const updateAllStepperStatus = (stepsValidationData: StepsValidationData = []) => {
    const newStepperStatus: StepStatus = {};
    Object.keys(stepStatus).forEach((stepKey, index) => {
      const step = Number(stepKey);
      const stepData = stepsValidationData[index];
      if (step === activeStep) {
        newStepperStatus[step] = 'active';
      } else if (stepData?.hasError) {
        newStepperStatus[step] = 'error';
      } else if (stepData?.isPopulated) {
        newStepperStatus[step] = 'completed';
      } else {
        newStepperStatus[step] = 'inactive';
      }
    });

    setStepStatus(newStepperStatus);
  };

  const updateStepperStatusByStepNumber = ({
    step,
    status,
  }: {
    step: keyof StepStatus;
    status: StepStatus[keyof StepStatus];
  }): boolean => {
    if (step > maxStep) return false;
    setStepStatus((prevStatus) => ({
      ...prevStatus,
      [step]: status,
    }));
    return true;
  };

  const resetStepperStatusByStepperNumber = (step: keyof StepStatus): boolean => {
    if (step > maxStep) return false;
    setStepStatus((prevStatus) => ({
      ...prevStatus,
      [step]: step === activeStep ? 'active' : 'inactive',
    }));
    return true;
  };

  return {
    activeStep,
    stepStatus,
    updateAllStepperStatus,
    updateStepperStatusByStepNumber,
    resetStepperStatusByStepperNumber,
    next,
    previous,
    finish,
    skipTo,
  };
};
